$(".text-desc-main-heading").click(function(){
  $(".text-desc-main-heading").removeClass('active');
  $(this).addClass('active');

  var id = $(this).attr('data_id');

  $(".text-desc-main-desc").removeClass('active');
  $(this).parents(".text-desc-inner-row").find('.text-desc-main-desc[data_id="' + id + '"]').addClass('active');
});


$(document).on("click",".product-card-wrapper .swatch-input__label",function() {
  var element = $(this).prev()
  var id = element.data('variant-id').trim();
  var parent = $(this).parents('.product-card-wrapper');

  parent.find('.swatch-input__input').removeAttr('checked');
  element.attr("checked", true);

  parent.find('.card__media img').addClass('hide');
  parent.find('.card__media img').removeClass('active');
  
  if(parent.find('.card__media img[variant-id="'+id+'"]').length > 0){
    parent.find('.card__media img[variant-id="'+id+'"]').addClass('active');
  }else{
    parent.find('.card__media img:first-child').addClass('active');
  }
});

$(".text-desc-main-heading").click(function(){
  $(this).parent().toggleClass('open');
  $(this).parents(".product-meta-accordion_item").find('.text-desc-main-desc').slideToggle();
});